import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTheme } from 'styled-components'

import { useNavigate } from '@/router-wrapper'
import { openUrl } from '@/utils/external-resources'
import { FlexRow, Margin } from '../../layout'
import { Span } from '../../typography/Body'
import { StCardButton } from './CardButton.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { To } from 'react-router-dom'

type CardButtonProps = {
  to: To
  label: string
  icon?: IconProp
  external?: boolean
  onClick?: () => void
  roundedTop?: boolean
  roundedBottom?: boolean
}

const CardButton = ({ icon, label, to, external, onClick, roundedTop, roundedBottom }: CardButtonProps) => {
  const theme = useTheme()
  const navigate = useNavigate()

  function handleClick() {
    onClick?.()
    if (external) {
      openUrl(to.toString())
    } else {
      navigate(to)
    }
  }

  return (
    <StCardButton onClick={handleClick} roundedTop={roundedTop} roundedBottom={roundedBottom}>
      <FlexRow alignItems='center'>
        {icon ? (
          <>
            <FontAwesomeIcon icon={icon} color={theme.Colors.Neutrals.Darkest} />
            <Margin mr={theme.UI.Spacing.Space3} />
          </>
        ) : null}

        <Span type='BodyMediumRegular' color={theme.Colors.Neutrals.Darkest}>
          {label}
        </Span>
      </FlexRow>

      <FontAwesomeIcon
        icon={external ? ['fal', 'external-link'] : ['far', 'chevron-right']}
        color={theme.Components.Button.Tertiary.Text}
      />
    </StCardButton>
  )
}

export { CardButton }
